import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 按需引入vant 组件
import '@/vant/index.js'
import '@vant/touch-emulator'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
